export default "__VITE_ASSET__tjM6I9G5__"